import React from 'react'
import { Oval } from 'react-loader-spinner'
import './loaderStyle.css';


const CircleLoade = () => {
    return (
        <div className="loader">
            <Oval
                height={100}
                width={100}
                color="#a7091e"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="#a7091e"
                strokeWidth={2}
                strokeWidthSecondary={2}
            />
        </div>
    )
}

export default CircleLoade